module.exports = __webpack_public_path__ + "static/CCQ_PTVI-33aeb3cc836f7e3ac676655039da17e5.jpg";